@if(showLayout){
<div class="layout-container" [ngStyle]="sidebarSize">
    <!-- Navbar -->
    <div class="app-navbar">
        <app-navbar />
    </div>

    <!-- Sidebar -->
    <div class="app-sidebar">
        <app-sidebar />
    </div>

    <!-- Main Content -->
    <div class="main-content">

        @if(authLoading){
            <div class="flex align-items-center justify-content-center h-full">
                <div class="mx-2">
                    <p-progressSpinner styleClass="w-8rem h-8rem" strokeWidth="4" fill="var(--surface-ground)"
                        animationDuration=".5s" />
                </div>
            </div>
        } @else {
            <div class="m-2">
                <router-outlet></router-outlet>
            </div>
        }

        <!-- Footer -->
        <div class="app-footer mt-4">
            <app-footer />
        </div>

    </div>
</div>

} @else {
    <div>
        <router-outlet></router-outlet>
    </div>
}
<p-toast position="bottom-center" [key]="globalErrorHandlerToastKey"
    [baseZIndex]="5000" class="error-toast">
    <ng-template let-message pTemplate="message">
        <div class="flex flex-column" style="flex: 1">
            <div class="text-center m-1">
                <i class="pi pi-exclamation-triangle" style="font-size: 3rem"></i>
                <h3>{{message.summary}}</h3>
                <div class="text-red-400" [innerHTML]="message.detail"></div>
            </div>
        </div>
    </ng-template>
</p-toast>
